import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Unveil } from '@homeaway/react-unveil';
import { fetchRecommendedDestinations } from '../../redux/modules/recommendedDestinations';
import AsyncRecommendedDestinations from './AsyncRecommendedDestinations';

class ConnectedRecommendedDestinations extends Component {
  componentDidMount() {
    this.props.fetchRecommendedDestinations({ limit: this.props.limit });
  }

  render() {
    const { data, title, subtitle } = this.props;

    return data.length >= 5 ? (
      <Unveil>
        <AsyncRecommendedDestinations {...{ data, title, subtitle }} />
      </Unveil>
    ) : null;
  }
}

ConnectedRecommendedDestinations.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    destinationUrl: PropTypes.string,
    imageUrl: PropTypes.string,
    lbsId: PropTypes.string,
    simpleDestinationName: PropTypes.string
  })),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  limit: PropTypes.number,
  fetchRecommendedDestinations: PropTypes.func.isRequired
};

ConnectedRecommendedDestinations.defaultProps = {
  limit: 8,
  data: []
};

const mapStateToProps = ({ recommendedDestinations }) => ({
  ...recommendedDestinations
});

const mapDispatchToProps = {
  fetchRecommendedDestinations
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedRecommendedDestinations);
